import {Paper, styled} from '@mui/material';
import {reverse} from 'named-urls';
import React, {useEffect, useMemo, useState} from 'react';
import {useRouteMatch} from 'react-router-dom';
import Switched from '../../../../components/Switched';
import Switcher from '../../../../components/Switcher';
import routes from '../../../../routes';
import Permissions from './Permissions';
import Jobs from './Jobs';

const Container = styled(Paper)(({theme}) => ({
  '&.MuiPaper-root': {
    overflow: 'hidden',
    marginTop: theme.spacing(1),
  }
}));

const Tabs = ({user, onUserUpdated}) => {
  const match = useRouteMatch();
  const [tab, setTab] = useState('loading');

  const tabs = useMemo(() => [
    {
      title: 'Permissions',
      slug: '',
      path: reverse(user.archived ? routes.archive.administrators.detail : routes.administrators.detail, {
        id: user?.id ?? 0
      })
    },
    {
      title: 'Jobs',
      slug: 'jobs',
      path: reverse(user.archived ? routes.archive.administrators.tab : routes.administrators.tab, {
        id: user?.id ?? 0,
        tab: 'jobs'
      })
    },
  ], [user]);

  useEffect(() => {
    if (match.params?.tab && tabs.findIndex(t => t.slug) >= 0) {
      setTab(match.params?.tab);
    } else {
      setTab('');
    }
  }, [match, tabs]);

  return (
    <>
      <Switcher tabs={tabs}/>
      <Switched tab="" currentTab={tab}>
        <Container>
          <Permissions user={user} onUpdated={onUserUpdated}/>
        </Container>
      </Switched>
      <Switched tab="jobs" currentTab={tab}>
        <Jobs user={user}/>
      </Switched>
    </>
  );
};

export default Tabs;
